import { Controller } from '@hotwired/stimulus';
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.css';

export default class extends Controller {
  connect() {
    if (
      this.choicesControl ||
      document.documentElement.hasAttribute('data-turbolinks-preview')
    ) {
      return;
    }

    const choices = JSON.parse(this.element.dataset['choicesJson']);
    this.choicesControl = new Choices(this.element, {
      shouldSort: false, // already sorted
      choices: choices,
    });
  }
}
